// extracted by mini-css-extract-plugin
export default {"SecondaryView__item":"SecondaryView_SecondaryView__item__1RQu4"};